var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonitur2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "23.214px",
    viewBox: "0 0 40 23.214",
    enableBackground: "new 0 0 40 23.214",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    d: "M10.995,18.38c4.62,0,8.38-3.76,8.38-8.38 s-3.76-8.37-8.38-8.37S2.625,5.38,2.625,10S6.375,18.38,10.995,18.38z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M16.239,11.144c0,0-0.524,1.633-0.76,2.356c-0.764,0-2.48-0.004-2.48-0.004l-2.476-0.004 l2.008,1.452c0,0,1.388,1.004,2.008,1.452c-0.236,0.728-0.772,2.355-0.772,2.355l-0.772,2.356l2.004-1.46c0,0,1.384-1.009,2-1.46 c0.616,0.451,2,1.46,2,1.46l2,1.455l-0.768-2.352c0,0-0.532-1.628-0.768-2.355c0.62-0.448,2.004-1.452,2.004-1.452l2.008-1.452 l-2.476,0.004c0,0-1.716,0.004-2.476,0.004c-0.236-0.724-0.764-2.356-0.764-2.356l-0.76-2.348L16.239,11.144z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    d: "M16.239,11.144c0,0-0.524,1.633-0.76,2.356 c-0.764,0-2.48-0.004-2.48-0.004l-2.476-0.004l2.008,1.452c0,0,1.388,1.004,2.008,1.452c-0.236,0.728-0.772,2.355-0.772,2.355 l-0.772,2.356l2.004-1.46c0,0,1.384-1.009,2-1.46c0.616,0.451,2,1.46,2,1.46l2,1.455l-0.768-2.352c0,0-0.532-1.628-0.768-2.355 c0.62-0.448,2.004-1.452,2.004-1.452l2.008-1.452l-2.476,0.004c0,0-1.716,0.004-2.476,0.004c-0.236-0.724-0.764-2.356-0.764-2.356 l-0.76-2.348L16.239,11.144z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    points: "25.998,11.39 25.058,14.303 21.997,14.297 24.477,16.092 23.525,19.001 25.998,17.197  28.472,19.001 27.52,16.092 30,14.297 26.939,14.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    points: "34.998,11.39 34.058,14.303 30.997,14.297 33.477,16.092 32.525,19.001 34.998,17.197  37.472,19.001 36.52,16.092 39,14.297 35.939,14.303  "
  }), /*#__PURE__*/React.createElement("polyline", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: " 7,9.75 10,12.75 15,7.75  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonitur2);
export default __webpack_public_path__ + "static/media/bonitur2.7454acf3bdc706e5ec6f0ad170bce622.svg";
export { ForwardRef as ReactComponent };